module.exports = __webpack_public_path__ + "img/dollar-icon.13d0e445.svg";